import React from "react";

export const FormError = ({ error }) => {
  return <h3 className="h3 conf-form__message">{error}</h3>;
};
